function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#A5ACB0",
  d: "M30 72h-2v-4H10v4H8v-6h22v6M50 72h-2V62H30v2h-2v-4h22v12M72 72h-2V56H50v2h-2v-4h24v18"
}), React.createElement("path", {
  d: "M37 10c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 8c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zM18 32a.997.997 0 01-.707-.293l-3-3a.999.999 0 010-1.414l7-7c.123-.123.276-.212.444-.258l11-3 .526 1.93-10.744 2.93L16.414 28 18 29.586l5.293-5.293a.998.998 0 01.464-.263l8-2 .486 1.94-7.732 1.933-5.804 5.804A.997.997 0 0118 32M47 51a1 1 0 01-.857-.485l-5.788-9.645-7.598-1.9.486-1.94 8 2a.997.997 0 01.614.455l5.524 9.206 2.31-1.154-4.455-9.801-9.683-4.841a1 1 0 01-.514-1.17l2-7a.999.999 0 01.851-.719l8.651-.961L52.586 17 51 15.414l-5.293 5.293A.997.997 0 0145 21h-7v-2h6.586l5.707-5.707a.999.999 0 011.414 0l3 3a.999.999 0 010 1.414l-7 7a.999.999 0 01-.597.287l-8.333.926-1.588 5.557 9.258 4.628c.205.103.368.272.463.481l5 11a1 1 0 01-.463 1.309l-4 2A1.004 1.004 0 0147 51",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M20 56a.998.998 0 01-.707-.293l-3-3a.999.999 0 010-1.414l7.833-7.833 2.889-8.667 1.024-11.143 1.991.183-1.034 11.258a1.012 1.012 0 01-.047.225l-3 9c-.05.147-.132.281-.242.391L18.414 52l1.653 1.653L30.13 45.42l2.912-9.707 1.916.574-3 10a.996.996 0 01-.325.487l-11 9A.998.998 0 0120 56",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationHop = function SvgIconIllustrationHop(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationHop;